export const filters = {
  role: 'Role',
  status: 'Status'
};

export const maxDisplayColumn = 7;

export const systemRole = 'System';
